import COM from "./Feature";

export default COM;


// WEBPACK FOOTER //
// ./src/js/components/Feature/index.js